import { ReactNode } from "react";

export default function LayoutWhite({ children }: { children: ReactNode }) {
  return (
    <main className="custom-container flex h-dvh flex-col overflow-y-auto bg-help-center-white pb-14 pt-8 text-black">
      {children}
    </main>
  );
}
